"use client";

import { createContext, useContext } from "react";

export type AppVariant = "default" | "admin";

const AppVariantContext = createContext<AppVariant>("default");

export const AppVariantProvider = AppVariantContext.Provider;

export function useAppVariant(): AppVariant {
  return useContext(AppVariantContext);
}
